<script setup lang="ts">
import type { SectionTitleRecord } from '~/types/datocms'

const props = defineProps<{
  data: SectionTitleRecord
  moduleIndex: number
}>()

const { level, isSemantic } = useSectionRules(props.moduleIndex, !!props.data.title)
</script>

<template>
  <div
    class="pb-4 pt-10 uppercase lg:pb-8 lg:pt-12"
    :class="data.background === 'Yellow' ? 'bg-yellow text-black' : 'bg-black text-yellow'"
  >
    <div class="container grid-default">
      <Heading
        v-if="data.title"
        :level="level"
        :size="5"
        :is-semantic="isSemantic"
        class="col-span-full md:col-span-10 lg:col-span-6"
      >
        <span class="font-normal [&>b]:font-semibold" v-html="data.title" />
      </Heading>
    </div>
  </div>
</template>
